import { FC } from 'react';
import parse from 'html-react-parser';
import cn from 'classnames';

import { BuilderString } from '@/shared/types';
import { cleanBuilderStringInput, getBuilderString } from '@/shared/text';
import { IconName } from '@/shared/constants/icons';

import { FlatMediaInput, Media } from '../Media';
import styles from './TabContent.module.scss';
import { Action, ActionVariant } from '../Action';

export interface TabInput extends FlatMediaInput {
  tabName: BuilderString;
  tabIcon: IconName;
  content: BuilderString;
  actionVariant?: ActionVariant;
  actionLabel?: BuilderString;
  actionUrl?: BuilderString;
}

interface Props extends TabInput {
  className?: string;
  locale: string;
}

export const TabContent: FC<Props> = ({
  className,
  locale,
  mediaType,
  mediaCaption,
  imageUrl,
  imageLink,
  imageLinkTarget,
  videoUrl,
  videoAutoPlay,
  youtubeUrl,
  youtubeDisabledDialog,
  content,
  actionVariant,
  actionLabel,
  actionUrl,
}) => (
  <div className={className}>
    <Media
      className={styles.media}
      containerClassName={styles.mediaContainer}
      locale={locale}
      mediaType={mediaType}
      mediaCaption={mediaCaption}
      image={imageUrl}
      imageLink={imageLink}
      imageLinkTarget={imageLinkTarget}
      video={{
        source: videoUrl || '',
        autoPlay: videoAutoPlay,
        poster: imageUrl,
      }}
      youtube={{
        url: youtubeUrl || '',
        poster: imageUrl || '',
        disabledDialog: youtubeDisabledDialog,
      }}
    />
    <div className={cn('u-m-t-xxl-6', 'u-m-t-sm-xl')}>
      <p className={'u-typography-h3'}>
        {parse(cleanBuilderStringInput(getBuilderString(content, locale)))}
      </p>
      <Action
        className={cn('u-m-t-xxl-6', 'u-m-t-sm-xl')}
        locale={locale}
        variant={actionVariant}
        label={actionLabel}
        url={actionUrl}
      />
    </div>
  </div>
);
